<template>
	<div class="container">
		<div class="tixingxuanze-top">
      <div  class="fanhui" v-if="isShowBack">
        <img src="../../../static/images/other-fanhui.png" @click="back" >
      </div>
      <div class="tab">题型选择</div>
		</div>
		<div class="tixingxuanze-mid">
			<div class="antixing">
				<div class="tit">按题型</div>
				<div class="items">
					<div>
						<img src="../../../static/images/other-panduanti.png" />
						<p>判断题</p>
						<p>256</p>
					</div>
					<div>
						<img src="../../../static/images/other-danxuanti.png" />
						<p>单选题</p>
						<p>256</p>
					</div>
					<div>
						<img src="../../../static/images/other-duoxuanti.png" />
						<p>多选题</p>
						<p>256</p>
					</div>
				</div>
			</div>
			<div class="anneirong">
				<div class="tit">按内容类型</div>
				<div class="items">
					<div>
						<img src="../../../static/images/other-wenziti.png" />
						<p>文字题</p>
						<p>256</p>
					</div>
					<div>
						<img src="../../../static/images/other-tuwenti.png" />
						<p>图文题</p>
						<p>256</p>
					</div>
					<div>
						<img src="../../../static/images/other-donghuati.png" />
						<p>动画题</p>
						<p>256</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'tixingxuanze',
	components: {
		// LearnTime
	},
	data() {
		return {
			show: false,
      isShowBack: false,
			images: [require('../../assets/images/banner-1.jpg'), require('../../assets/images/banner-2.jpg')]
		};
	},
	created() {
    if (this.GetRequest('channel') == 'exejH5') {
      this.isShowBack = true
    }
		document.documentElement.style.fontSize = "625%"
	},
	methods: {
    back() {
      this.$router.go(-1); //返回上一层
    },
		gotopage() {
			this.$router.push({
				name: 'tixingxuanze',
				params: { name: 'item', id: 1 }
			});
		}
	},
	afterDestory(){
		document.documentElement.style.fontSize = ""
	}
};
</script>

<style lang="scss" scoped>
html {
	background-color: #fff;
}
</style>
<style lang="scss" scoped>
html {
	font-size: 625%;
}
.container {
	width: 100%;
	font-size: 0.18rem;
	.tixingxuanze-top {
		display: flex;
		width: 100%;
		height: 0.5rem;
		border-bottom: 1px solid #dcdcdc;
		.fanhui {
			position: absolute;
			top: 0.23rem;
			left: 0.23rem;
			width: 0.07rem;
			height: 0.13rem;
			img {
				width: 100%;
				height: 100%;
			}
		}
		.tab {
			position: absolute;
			width: 100%;
			margin: 0 auto;
			color: #333;
			margin-top: 0.2rem;
			font-size: 0.18rem;
			height: 0.29rem;
			line-height: 0.29rem;
			letter-spacing: 2px;
			text-align: center;
		}
	}
	.tixingxuanze-mid {
		font-size: 0.18rem;
		color: #333333;
		width: 92%;
		margin-left: 4%;
		.antixing {
			margin-top: 0.2rem;
			.items {
				display: flex;
				width: 100%;
				div {
					width: 33%;
					text-align: center;
					margin-top: 0.15rem;
					img {
						width: 0.5rem;
						height: 0.5rem;
						margin: 0;
						padding: 0;
					}
					p {
						margin: 0;
						padding: 0;
					}
					p:nth-child(2) {
						margin-top: 0;
						padding-top: 0;
						font-size: 0.14rem;
						color: #333;
					}
					p:nth-child(3) {
						font-size: 0.12rem;
						color: #999999;
						margin-top: 0.06rem;
					}
				}
			}
		}
		.anneirong {
			margin-top: 0.23rem;
			.items {
				display: flex;
				width: 100%;
				div {
					width: 33%;
					text-align: center;
					margin-top: 0.15rem;
					img {
						width: 0.5rem;
						height: 0.5rem;
						margin: 0;
						padding: 0;
					}
					p {
						margin: 0;
						padding: 0;
					}
					p:nth-child(2) {
						margin-top: 0;
						padding-top: 0;
						font-size: 0.14rem;
						color: #333;
					}
					p:nth-child(3) {
						font-size: 0.12rem;
						color: #999999;
						margin-top: 0.06rem;
					}
				}
			}
		}
	}
}
</style>
